import { type TermLifeStepParams, yearlyIncomeSchema } from '@flows/configs/de/termLife/steps/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

export const yearlyIncome = (params: TermLifeStepParams) => {
  const schema = yearlyIncomeSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_termLife:steps.yearly_income.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_term_life_insurance_de.shape.configuration_parameters.shape.income.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_termLife:steps.yearly_income.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('income'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'login',
    subFlow: SubFlow.TermLife,
  } as const satisfies AnyStepConfiguration
}
